(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/settings-selector/settings-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/settings-selector/settings-selector.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const _svs$ui = svs.ui,
  ReactIconButton = _svs$ui.ReactIconButton,
  ReactIcon = _svs$ui.ReactIcon;
const analytics = svs.components.analytics;
const _svs$components$tipse = svs.components.tipsen.tipsenModal,
  TipsenModal = _svs$components$tipse.TipsenModal,
  StickyBottom = _svs$components$tipse.StickyBottom,
  StickyButtonClose = _svs$components$tipse.StickyButtonClose,
  ModalHeader = _svs$components$tipse.ModalHeader;
const _svs$components$tipse2 = svs.components.tipsen.selectors,
  selectShowCompressedCoupon = _svs$components$tipse2.selectShowCompressedCoupon,
  selectShowVideoAnalysesInCoupon = _svs$components$tipse2.selectShowVideoAnalysesInCoupon,
  selectShowMatchAnalysesInCoupon = _svs$components$tipse2.selectShowMatchAnalysesInCoupon;
const selectDisplayName = svs.components.tipsen.engine.selectors.engineSelectors.selectDisplayName;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const _React = React,
  useRef = _React.useRef;
const SettingsSelectorContainer = svs.components.tipsen.routePlaySpela.SettingsSelectorContainer;
const SettingsStickyBottom = _ref => {
  let trackEventOnExitSettings = _ref.trackEventOnExitSettings,
    onClose = _ref.onClose;
  return React.createElement(StickyBottom, null, React.createElement(StickyButtonClose, {
    onClick: e => {
      trackEventOnExitSettings();
      onClose(e);
    }
  }));
};
const getStartUpSettingValues = _ref2 => {
  let showCompressedCoupon = _ref2.showCompressedCoupon,
    showVideoAnalysesInCoupon = _ref2.showVideoAnalysesInCoupon,
    showMatchAnalysesInCoupon = _ref2.showMatchAnalysesInCoupon,
    tipsinfoOptions = _ref2.tipsinfoOptions;
  const tipsinfoValues = tipsinfoOptions === null || tipsinfoOptions === void 0 ? void 0 : tipsinfoOptions.map(tipsinfoItem => {
    const key = tipsinfoItem.key;
    const isSelected = tipsinfoItem.isSelected;
    return {
      key,
      isSelected
    };
  });
  const settingValues = {
    showCompressedCoupon,
    showVideoAnalysesInCoupon,
    showMatchAnalysesInCoupon,
    tipsinfoValues
  };
  return settingValues;
};
const renderSettingsStickyBottom = (onClose, trackEventOnExitSettings) => React.createElement(SettingsStickyBottom, {
  onClose: onClose,
  trackEventOnExitSettings: trackEventOnExitSettings
});
const SettingsSelector = _ref3 => {
  let tipsinfoOptions = _ref3.tipsinfoOptions,
    isOpen = _ref3.isOpen,
    onClose = _ref3.onClose;
  const displayName = useSelector(selectDisplayName);
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const showCompressedCoupon = useSelector(selectShowCompressedCoupon);
  const showVideoAnalysesInCoupon = useSelector(selectShowVideoAnalysesInCoupon);
  const showMatchAnalysesInCoupon = useSelector(selectShowMatchAnalysesInCoupon);
  const startUpSettingValues = useRef(getStartUpSettingValues({
    showCompressedCoupon,
    showVideoAnalysesInCoupon,
    showMatchAnalysesInCoupon,
    tipsinfoOptions
  }));
  const trackEventOnExitSettings = () => {
    const selectedOptions = tipsinfoOptions.filter(option => option.isSelected).map(option => option.title);
    analytics.trackEvent({
      category: "Nya tipsen - Inst\xE4llningar",
      action: 'Tipsinfo',
      opt_label: selectedOptions.join(', ')
    });
    if (startUpSettingValues.current.showCompressedCoupon !== showCompressedCoupon) {
      analytics.trackEvent({
        category: "Nya tipsen - Inst\xE4llningar",
        action: 'compact_coupon',
        opt_label: showCompressedCoupon
      });
    }
    if (startUpSettingValues.current.showVideoAnalysesInCoupon !== showVideoAnalysesInCoupon) {
      analytics.trackEvent({
        category: 'Nya Tipsen',
        action: "Videoanalyser ".concat(showVideoAnalysesInCoupon ? 'aktiverad' : 'avaktiverad'),
        opt_label: displayName
      });
    }
  };
  if (isExtraSmall) {
    return React.createElement(TipsenModal, {
      Bottom: () => renderSettingsStickyBottom(onClose, trackEventOnExitSettings),
      className: "tipsen-modal-window",
      isOpen: isOpen
    }, React.createElement("div", {
      className: "pg_coupon_settings_selector__container",
      "data-testid": "settings"
    }, React.createElement(ModalHeader, null, "Anpassa kupong"), React.createElement(SettingsSelectorContainer, null)));
  }
  return React.createElement(ErrorBoundary, null, React.createElement("div", {
    className: "pg_coupon_settings_selector__container",
    "data-testid": "settings"
  }, React.createElement(ReactIconButton, {
    className: "pg_coupon_settings_selector__close_btn",
    onClick: e => {
      trackEventOnExitSettings();
      onClose(e);
    }
  }, React.createElement(ReactIcon, {
    icon: "close",
    size: "300"
  })), React.createElement(SettingsSelectorContainer, null)));
};
setGlobal('svs.components.tipsen.routePlaySpela.SettingsSelector', SettingsSelector);

 })(window);